var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",style:('background-image: url(' + (require(`../../assets/img/${_vm.imgBg}.webp`)) + ')'),attrs:{"id":"emphasis"}},[_c('div',{staticClass:"container"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }